// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3lO-i","upload":"Small_upload__1IyqU","imageWrap":"Small_imageWrap__1iWLY","removeBtn":"Small_removeBtn__23KKJ"};